import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AllJobsComponent } from './jobs/all-jobs/all-jobs.component';
import { MyJobRequestComponent } from './jobs/my-job-request/my-job-request.component';
import { CreateJobRequestComponent } from './jobs/create-job-request/create-job-request.component';
import { ReviewJobRequestComponent } from './jobs/review-job-request/review-job-request.component';
import { AllJobChainsComponent } from './jobs/all-job-chains/all-job-chains.component';
import { CreateJobChainComponent} from './jobs/create-job-chain/create-job-chain.component';
import { BudgetComponent } from './masterdata/budget/budget.component';
import { CompaniesComponent } from './masterdata/companies/companies.component';
import { DepartmentsComponent } from './masterdata/departments/departments.component';
import { EmployeesComponent } from './masterdata/employees/employees.component';
import { JobCategoriesComponent } from './masterdata/job-categories/job-categories.component';
import { JobTypesComponent } from './masterdata/job-types/job-types.component';
import { AllBudgetRequestsComponent } from './budget/all-budget-requests/all-budget-requests.component';
import { BudgetStatusComponent } from './budget/budget-status/budget-status.component';
import { MyBudgetRequestsComponent } from './budget/my-budget-requests/my-budget-requests.component';
import { ReviewBudgetRequestsComponent } from './budget/review-budget-requests/review-budget-requests.component';
import { AllTemplatesComponent } from './templates/all-templates/all-templates.component';
import { CreateTemplateComponent } from './templates/create-template/create-template.component';
import { BudgetConsumptionReportComponent } from './reports/budget-consumption-report/budget-consumption-report.component';
import { JobChainCycleReportComponent } from './reports/job-chain-cycle-report/job-chain-cycle-report.component';
import { AccountSettinngsComponent } from './settings/account-settinngs/account-settinngs.component';
import { AddCompanyComponent } from './masterdata/add-company/add-company.component';
import { VehiclesComponent } from './masterdata/vehicles/vehicles.component';
import { BudgetRequestDetailsComponent } from './budget/budget-request-details/budget-request-details.component';
import { AddVehicleComponent } from './masterdata/add-vehicle/add-vehicle.component';
import { JobRequestDetailsComponent } from './jobs/job-request-details/job-request-details.component';
import { AddBudgetAllocationComponent } from './budget/add-budget-allocation/add-budget-allocation.component';
import { BudgetAllocationsComponent } from './budget/budget-allocations/budget-allocations.component';

const routes: Routes = [
  {path:'budget', component:BudgetComponent}, /* added */
  {path:'companies', component:CompaniesComponent}, /* added */
  {path:'departments', component:DepartmentsComponent}, /* added */
  {path:'employees', component:EmployeesComponent}, /* added */
  {path:'jobCategories', component:JobCategoriesComponent}, /* added */
  {path:'jobTypes', component:JobTypesComponent}, /* added */
  {path:'addCompany', component:AddCompanyComponent}, /* added */
  {path:'vehicles', component:VehiclesComponent}, /* added */
  {path:'addVehicle', component:AddVehicleComponent},


  
  {path:'allJobs', component:AllJobsComponent}, /* added */
  {path:'myJobRequests', component:MyJobRequestComponent}, /* added */
  {path:'createJobRequest', component:CreateJobRequestComponent}, /* added */
  {path:'reviewJobRequest', component:ReviewJobRequestComponent}, /* added */
  {path:'allJobChains', component:AllJobChainsComponent}, /* added */
  {path:'createJobChain', component:CreateJobChainComponent}, /* added */
  {path:'jobRequestDetails', component:JobRequestDetailsComponent},


  {path:'allBudgetRequests', component:AllBudgetRequestsComponent}, /* added */
  {path:'budgetStatus', component:BudgetStatusComponent}, /* added */
  {path:'myBudgetRequets', component:MyBudgetRequestsComponent}, /* added */
  {path:'reviewBudgetRequests', component:ReviewBudgetRequestsComponent}, /* added */
  {path:'budgetRequestDetails', component:BudgetRequestDetailsComponent}, /* added */
  {path: 'addBudgetAllocation', component:AddBudgetAllocationComponent},
  {path:'budgetAllocations', component:BudgetAllocationsComponent},

  {path:'allTemplates', component:AllTemplatesComponent}, /* added */
  {path:'createTemplate', component:CreateTemplateComponent},

  {path:'budgetConsumptionReport', component:BudgetConsumptionReportComponent}, /* added */
  {path:'jobChainCycleReport', component:JobChainCycleReportComponent}, /* added */

  {path:'accountSettings', component:AccountSettinngsComponent} /* added */

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
